import * as types from './machineParameterActionTypes.js';

export const setRpmPump = (rpmPump) => ({ type: types.SET_RPMPUMP, rpmPump: rpmPump });
export const setSpeed = (speed) => ({ type: types.SET_SPEED, speed: speed });
